const DESCRIPTION_QUERY_KEY = "leads-search-filters:description";

export const leadsSearchFiltersQueryKeys = {
    description: () => [DESCRIPTION_QUERY_KEY] as const,
};
